module.exports = __webpack_public_path__ + "static/media/johm.9a819ee3.jpg";